import accounting from 'accounting';

const costRecoveryHandler = (totalPrice, totalCost) => {
  return `${accounting.format((totalPrice / (totalCost || undefined)) * 100 || 0, 1)}%`;
};

export { costRecoveryHandler };
